import { FC, PropsWithChildren } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

type Props = {
  label: string;
};

const Container = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0, theme.spacingSizes.sm),
}));

const Value = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  alignContent: 'center',
  alignItems: 'flex-start',
  gap: 0,
});

const RecordRow: FC<PropsWithChildren<Props>> = ({ label, children }) => {
  return (
    <Container container spacing={{ xs: 0, sm: 6 }}>
      <Grid size={{ xs: 12, sm: 3 }}>
        <Typography variant="h6">{label}</Typography>
      </Grid>
      <Value size={{ xs: 12, sm: 9 }}>
        <Typography variant="body2" color="grey.900">
          {children}
        </Typography>
      </Value>
    </Container>
  );
};

export default RecordRow;
